import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
// import { logout, setCurrentUser } from "../store/storeActions";
import { Box, CircularProgress } from "@material-ui/core";
import { Get } from "../actions/apiActions";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import { SET_USER_DATA } from "../constants/types";

export const AuthGuard = ({ children, roles }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { user } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch user info from API to get roles and authentication status
    Get(
      {},
      "Auth/info",
      null,
      (res) => {
        
        dispatch({type:SET_USER_DATA,payload:{firstName: res.data.firstName,lastName:res.data.lastName,email:res.data.email,id:res.data.id,roles:res.data.roles}}); // Store user info including roles
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        dispatch({type:"LOGOUT"}); // Log the user out if fetching info fails
        history.push("/login");
      }
    );
  }, [dispatch, history]);

  // Handle loading state
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center">
        <CircularProgress color="error" />
      </Box>
    );
  }

  // Role-based access control
  if (roles && user && !roles.some((role) => user.roles.includes(role))) {
    
    return <Redirect to="/account/profile" replace />;
  }

  return <>{children}</>;
};
